import * as React from "react"

function Badge({ variant = "default", className = "", children, ...props }) {
  const baseStyles = "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold"
  
  const variants = {
    default: "bg-[#1a4a1a] text-white",
    secondary: "bg-gray-100 text-gray-900",
    outline: "border border-[#1a4a1a] text-[#1a4a1a]"
  }

  const classes = `${baseStyles} ${variants[variant]} ${className}`

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  )
}

export { Badge } 